import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, IntegerDecoder } from '@simonbackx/simple-encoding';
import { BalanceItem, BalanceItemWithPayments } from '../BalanceItem.js';
import { PaymentGeneral } from '../members/PaymentGeneral.js';
import { BaseOrganization, Organization } from '../Organization.js';
import { upgradePriceFrom2To4DecimalPlaces } from '../upgradePriceFrom2To4DecimalPlaces.js';
import { Payment } from '../members/Payment.js';
export class PayableBalance extends AutoEncoder {
    organization;
    amountPaid = 0;
    amountOpen = 0;
    amountPending = 0;
}
__decorate([
    field({ decoder: Organization })
], PayableBalance.prototype, "organization", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 354 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], PayableBalance.prototype, "amountPaid", void 0);
__decorate([
    field({ decoder: IntegerDecoder, field: 'amount' }),
    field({ decoder: IntegerDecoder, version: 354 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], PayableBalance.prototype, "amountOpen", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 335 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], PayableBalance.prototype, "amountPending", void 0);
export class PayableBalanceCollection extends AutoEncoder {
    /**
     * Debt you have to other organizations
     */
    organizations = [];
}
__decorate([
    field({ decoder: new ArrayDecoder(PayableBalance) })
], PayableBalanceCollection.prototype, "organizations", void 0);
export class DetailedPayableBalance extends AutoEncoder {
    organization;
    balanceItems = [];
    // todo
    payments = [];
    get filteredBalanceItems() {
        return BalanceItem.filterBalanceItems(this.balanceItems);
    }
    get payableBalanceItems() {
        return BalanceItem.filterPayableBalanceItems(this.balanceItems);
    }
    get discountBalanceItems() {
        return BalanceItem.filterDiscountBalanceItems(this.balanceItems);
    }
}
__decorate([
    field({ decoder: BaseOrganization })
], DetailedPayableBalance.prototype, "organization", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(BalanceItemWithPayments) })
], DetailedPayableBalance.prototype, "balanceItems", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(PaymentGeneral) }),
    field({ decoder: new ArrayDecoder(Payment), ...NextVersion })
], DetailedPayableBalance.prototype, "payments", void 0);
export class DetailedPayableBalanceCollection extends AutoEncoder {
    /**
     * Debt you have to other organizations
     */
    organizations = [];
}
__decorate([
    field({ decoder: new ArrayDecoder(DetailedPayableBalance) })
], DetailedPayableBalanceCollection.prototype, "organizations", void 0);
//# sourceMappingURL=PayableBalanceCollection.js.map